<template>
  <div>
    <!-- Infos générales -->
    <b-card class="mt-2 mb-4 shadow-sm">
      <div class="row">
        <div class="col-md-6">
          <div class="d-flex flex-column mb-4">
            <div class="bold-text"> {{ $t('contrat.name.label') }}</div>
            <div> {{ contrat.name }}</div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex flex-column mb-4">
            <div class="bold-text"> {{ $t('contrat.initialPayment.label') }}</div>
            <div> {{ convertToEuros(contrat.initialPayment) }}</div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex flex-column mb-4">
            <div class="bold-text"> {{ $t('Operation') }}</div>
            <b-link @click="goToOperation">
              {{ contrat.operation.tostring }}
            </b-link>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex flex-column mb-4">
            <div class="bold-text"> {{ $t('contrat.rendement.label') }}</div>
            <div> {{ convertToPercentage(contrat.rendement) }}</div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex flex-column mb-4">
            <div class="bold-text"> {{ $t('contrat.datePayment.label') }}</div>
            <div> {{ convertDateToStr(contrat.datePayment) }}</div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex flex-column mb-4">
            <div class="bold-text"> {{ $t('contrat.deadline.label') }}</div>
            <div> {{ convertDateToStr(contrat.deadline) }}</div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex flex-column mb-4">
            <div class="bold-text"> {{ $t('Bilan') }}</div>
            <div :class="{'bilan-exe':contrat.bilanType==='EXE','bilan-avp':contrat.bilanType==='AVP'}"
                 class="pastille-fail">
              {{ contrat.bilanType }}
            </div>
          </div>
        </div>
      </div>
    </b-card>

    <b-card class="shadow-sm my-2">
      <div class="level-two-title main-red-color bold-text">
        {{ $t('contrat.history.refunds') }}
      </div>

      <div v-for="(refund, index) in refunds" :key="index">
        <div class="row align-items-center my-3 mx-2">
          <div class="col-md-4">
            <div class="d-flex flex-column">
              <div class="bold-text"> {{ $t('Refund') }}</div>
              <div> {{ convertToEuros(refund.amount) }}</div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="d-flex flex-column">
              <div class="bold-text"> {{ $t('refund.dateRefund') }}</div>
              <div> {{ convertDateToStr(refund.dateRefund) }}</div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="d-flex flex-column">
              <div class="bold-text"> {{ $t('refund.contrat.Total') }}</div>
              <div> {{ convertToEuros(refund.total) }}</div>
            </div>
          </div>

          <b-row align-h="end" class="col-md-2">
            <button class="main-color transparent-btn" @click="clickOnEditRefundBtn(refund.id)">
              <pencil-icon size="18"/>
            </button>
            <button class="delete-color transparent-btn" @click="$emit('delete-refund', refund)">
              <trash-icon size="18"/>
            </button>
          </b-row>
        </div>

        <div v-if="index < refunds.length - 1">
          <div class="horizontal-line-main-color"></div>
        </div>
      </div>

      <div v-if="refunds.length === 0 || refunds[0].total < contrat.initialPayment" class="row mt-3">
        <div class="col-md-12">
            <span class="bold-text addLink" @click="addRefund">
              + {{ $t('Add') }} {{ $t('refund') }}
            </span>
        </div>
      </div>
    </b-card>

    <b-card class="shadow-sm my-2">
      <div class="level-two-title main-red-color bold-text">
        {{ $t('contrat.history.interests') }}
      </div>

      <div v-for="(interest, index) in interests" :key="index">
        <div class="row align-items-center my-3 mx-2">
          <div class="col-md-4">
            <div class="d-flex flex-column">
              <div class="bold-text"> {{ $t('Versement') }}</div>
              <div> {{ convertToEuros(interest.amount) }}</div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex flex-column">
              <div class="bold-text"> {{ $t('interest.dateInterest') }}</div>
              <div> {{ convertDateToStr(interest.dateInterest) }}</div>
            </div>
          </div>

          <b-row align-h="end" class="col-md-2">
            <button class="main-color transparent-btn" @click="clickOnEditInterestBtn(interest.id)">
              <pencil-icon size="18"/>
            </button>
            <button class="delete-color transparent-btn" @click="$emit('delete-interest', interest)">
              <trash-icon size="18"/>
            </button>
          </b-row>
        </div>

        <div v-if="index < interests.length - 1">
          <div class="horizontal-line-main-color"></div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-12">
            <span class="bold-text addLink" @click="addInterest">
              + {{ $t('Add') }} {{ $t('versement') }}
            </span>
        </div>
      </div>
    </b-card>

    <b-card class="shadow-sm my-2">
      <div class="level-two-title main-red-color bold-text">
        {{ $t('contrat.history.refunds.sell') }}
      </div>

      <div v-for="(refund, index) in refundSell" :key="index">
        <div class="row align-items-center my-3 mx-2">
          <div class="col-md-4">
            <div class="d-flex flex-column">
              <div class="bold-text"> {{ $t('Refund') }}</div>
              <div> {{ convertToEuros(refund.montant) }}</div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="d-flex flex-column">
              <div :class="{'main-green-color':refund.date<=new Date().getTime()}" class="bold-text">
                {{ $t('interest.dateInterest') }}
              </div>
              <div> {{ convertDateToStr(refund.date) }}</div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="d-flex flex-column">
              <div class="bold-text"> {{ $t('Lot') }}</div>
              <b-link @click="goToOperation">
                <div> {{ refund.operationLot.name }}</div>
              </b-link>
            </div>
          </div>
        </div>
        <div v-if="index < refundSell.length - 1">
          <div class="horizontal-line-main-color"></div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import api from "../../../services/api";

export default {
  name: "InvestorContratDetails",
  props: {
    contrat: { type: Object, required: true }
  },
  data() {
    return {
      refunds: [],
      interests: [],
      refundSell: [],
      selectedRefund: null,
      selectedInterest: null
    }
  },
  mounted() {
    this.fetchData()
  },
  watch: {
    contrat: {
      deep: true,
      immediate: false,
      handler() {
        if (this.contrat && this.contrat.id) {
          this.fetchData()
        }
      }
    }
  },
  methods: {
    convertDateToStr(dateMillis) {
      return new Date(dateMillis).toLocaleDateString()
    },
    convertToEuros(value) {
      let euros = (value / 100).toFixed(2)
      return Intl.NumberFormat().format(euros) + " €"
    },
    convertToPercentage(value) {
      return value.toString() + " %"
    },

    async fetchData() {
      if (!this.contrat || !this.contrat.id) return
      await this.fetchRefundsSell()
      await this.fetchRefunds()
      await this.fetchInterests()
    },

    async fetchRefundsSell() {
      await api
        .get(`/investorContrat/getRemboursementForInvestor/${this.contrat.id}`)
        .then(response => { this.refundSell = response.data })
    },
    async fetchRefunds() {
      await api
        .get(`/investorRefund/getAllRefundsForContrat/${this.contrat.id}`)
        .then(response => { this.refunds = response.data })
    },
    async fetchInterests() {
      await api
        .get(`/investorInterest/getAllInterestsForContrat/${this.contrat.id}`)
        .then(response => { this.interests = response.data })
    },

    clickOnEditInterestBtn(id) {
      this.$router.push({
        name: 'InvestorInterestCreateEdit',
        params: {
          investorInterestId: id,
          investorContratId: this.contrat.id,
          investorName: this.contrat.name + ' - ' + this.contrat.bilanType
        }
      })
    },
    clickOnDeleteInterestBtn(interest) {
      this.selectedInterest = interest
      this.$bvModal.show('interest-delete-modal')
    },
    addInterest() {
      this.$router.push({
        name: 'InvestorInterestCreateEdit',
        params: {
          investorInterestId: null,
          investorContratId: this.contrat.id,
          investorName: this.contrat.name + ' - ' + this.contrat.bilanType
        }
      })
    },

    clickOnEditRefundBtn(id) {
      this.$router.push({
        name: 'InvestorRefundCreateEdit',
        params: {
          investorRefundId: id,
          investorContratId: this.contrat.id,
          operationId: this.contrat.operation.id,
          investorName: this.contrat.name + ' - ' + this.contrat.bilanType
        }
      })
    },
    clickOnDeleteRefundBtn(refund) {
      this.selectedRefund = refund
      this.$bvModal.show('refund-delete-modal')
    },
    addRefund() {
      this.$router.push({
        name: 'InvestorRefundCreateEdit',
        params: {
          investorRefundId: null,
          operationId: this.contrat.operation.id,
          investorContratId: this.contrat.id,
          investorName: this.contrat.name + ' - ' + this.contrat.bilanType
        }
      })
    },

    goToOperation() {
      this.$router.push({
        name: 'OperationShow',
        params: {
          operationId: this.contrat.operation.id,
          currentSection: 0
        }
      })
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/investor/components/InvestorContratDetails.vue